import { LogoLoader as UiLogoLoader } from '@integration-app/console/components/Loader'
import { Popup as ConsolePopup } from '@integration-app/console/components/Popup'
import clsx from 'clsx'

function LogoLoader({ className = '', ...props }) {
  return <UiLogoLoader className={clsx('util-loader--logo', className)} {...props} />
}

export function EmptyPageLoader() {
  return (
    <div className={'noJsAppWrapper'}>
      <div className={'noJsAppBackdrop'} />
      <div className={'noJsAppSkeleton'}>
        <LogoLoader className={'noJsSpinner'} />
      </div>
    </div>
  )
}

export function PaneLogoLoader() {
  return (
    <ConsolePopup.Content display='grid' placeContent='center' w='full' h='full'>
      <LogoLoader />
    </ConsolePopup.Content>
  )
}
